var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkTemporary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 18.533 90 c -4.95 0 -9.604 -1.928 -13.105 -5.429 C 1.928 81.071 0 76.418 0 71.467 c 0 -4.95 1.928 -9.604 5.428 -13.104 L 26.49 37.3 c 7.226 -7.227 18.984 -7.227 26.209 0 c 1.172 1.171 1.172 3.071 0 4.242 c -1.172 1.172 -3.07 1.172 -4.242 0 c -4.887 -4.886 -12.838 -4.886 -17.725 0 L 9.67 62.604 C 7.304 64.972 6 68.119 6 71.467 s 1.304 6.495 3.67 8.862 C 12.038 82.696 15.186 84 18.533 84 s 6.495 -1.304 8.862 -3.671 l 16.375 -16.374 c 1.171 -1.172 3.07 -1.172 4.242 0 s 1.172 3.071 0 4.242 L 31.638 84.571 C 28.138 88.072 23.483 90 18.533 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 50.405 58.119 c -4.746 0 -9.492 -1.807 -13.105 -5.42 c -1.172 -1.171 -1.172 -3.071 0 -4.242 c 1.171 -1.172 3.071 -1.172 4.242 0 c 2.368 2.367 5.515 3.671 8.863 3.671 s 6.495 -1.304 8.862 -3.671 l 21.062 -21.062 C 82.696 25.028 84 21.881 84 18.533 s -1.304 -6.495 -3.671 -8.862 C 77.962 7.304 74.814 6 71.467 6 s -6.495 1.304 -8.862 3.671 L 46.229 26.045 c -1.171 1.172 -3.071 1.172 -4.242 0 c -1.172 -1.171 -1.172 -3.071 0 -4.242 L 58.362 5.428 C 61.862 1.928 66.517 0 71.467 0 c 4.951 0 9.604 1.928 13.104 5.428 C 88.072 8.929 90 13.583 90 18.533 s -1.928 9.604 -5.429 13.105 L 63.51 52.699 C 59.896 56.313 55.151 58.119 50.405 58.119 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTemporary);
export default __webpack_public_path__ + "static/media/link-temporary.5b8a946b1e478331a5c5a6bf74d5c021.svg";
export { ForwardRef as ReactComponent };